module.exports = __webpack_public_path__ + "assets/img/brandLogo2.a339d6c6.jpg";